import { SportSliderDict } from '@draftkings/sportsbook-common-contracts';
import { useAppProps } from '../../contexts';

import './index.scss';

type SideButtonProps = {
    position: 'left' | 'right';
    type: keyof ButtonMap;
    onClick(direction: keyof ButtonMap): void;
};

type ButtonConfig = {
    Icon: () => JSX.Element;
    labelDictKey: keyof SportSliderDict;
};

type ButtonMap = {
    'arrow-left': ButtonConfig;
    'arrow-right': ButtonConfig;
    refresh: ButtonConfig;
};

export const SideButton = ({ position, type, onClick }: SideButtonProps) => {
    const handleOnClick = () => onClick(type);
    const { dictionary } = useAppProps();
    const { Icon, labelDictKey } = buttonMap[type];
    const label = dictionary[labelDictKey];

    return (
        <div className={`sl-slider__button-container sl-slider__button-container--${position}`}>
            <button
                type="button"
                className="sl-slider__button"
                data-testid="sl-slider-button"
                aria-label={label}
                title={label}
                onClick={handleOnClick}
            >
                <Icon />
            </button>
        </div>
    );
};

const buttonMap: ButtonMap = {
    'arrow-left': {
        Icon() {
            return (
                <svg
                    className="sl-slider__button-icon"
                    data-testid="sl-slider-arrow-left"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    aria-hidden="true"
                >
                    <path
                        d="M12.5 16.25L6.25 10L12.5 3.75"
                        stroke="#ABABAB"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        },
        labelDictKey: 'arrowLeft'
    },
    'arrow-right': {
        Icon() {
            return (
                <svg
                    className="sl-slider__button-icon"
                    data-testid="sl-slider-arrow-right"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    aria-hidden="true"
                >
                    <path
                        d="M7.5 3.75L13.75 10L7.5 16.25"
                        stroke="#ABABAB"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        },
        labelDictKey: 'arrowRight'
    },
    refresh: {
        Icon() {
            return (
                <svg
                    className="sl-slider__button-icon"
                    data-testid="sl-slider-refresh"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    aria-hidden="true"
                >
                    <path
                        d="M6.23437 7.78906H2.48438V4.03906"
                        stroke="#ABABAB"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M5.14063 14.8594C6.10189 15.8214 7.32689 16.4768 8.66066 16.7425C9.99443 17.0082 11.3771 16.8724 12.6336 16.3522C13.8902 15.832 14.9642 14.9508 15.7199 13.8201C16.4756 12.6894 16.879 11.36 16.879 10C16.879 8.64002 16.4756 7.31058 15.7199 6.17987C14.9642 5.04917 13.8902 4.16798 12.6336 3.64779C11.3771 3.12761 9.99443 2.99179 8.66066 3.25752C7.32689 3.52324 6.10189 4.17858 5.14063 5.14063L2.48438 7.78907"
                        stroke="#ABABAB"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        },
        labelDictKey: 'refresh'
    }
};
